<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div class="p-24 pb-0" fxLayout="column" fxLayoutAlign="start">
    <mat-horizontal-stepper [linear]="true" labelPosition="bottom" #stepper (selectionChange)="onStepChange($event)" [class.hidden]="performanceTeamReview">
        <mat-step [completed]="formGroup.valid">
            <ng-template matStepLabel>{{ 'GROUPS.LABEL.GENERAL_INFO' | translate }}</ng-template>

            <form [formGroup]="formGroup">
                <div fxLayout="column">
                    <mat-form-field>
                        <mat-label>{{ 'GENERAL.PROPERTY.NAME' | translate }}</mat-label>
                        <input matInput name="name" formControlName="name" />
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>{{ 'GENERAL.PROPERTY.TYPE' | translate }}</mat-label>
                        <mat-select formControlName="type">
                            <mat-option *ngFor="let performanceTemplateType of performanceTeamTemplateTypes" [value]="performanceTemplateType.id">
                                {{ performanceTemplateType.name | translate }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field>
                        <input
                            matInput
                            [matDatepicker]="pickerValidFrom"
                            formControlName="startDate"
                            (focus)="pickerValidFrom.open()"
                            [placeholder]="'GENERAL.PROPERTY.START_DATE' | translate"
                            (dateChange)="updateDueDate()"
                        />
                        <mat-datepicker-toggle matSuffix [for]="pickerValidFrom"></mat-datepicker-toggle>
                        <mat-datepicker #pickerValidFrom></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field>
                        <input
                            matInput
                            formControlName="dueDate"
                            [min]="minDate"
                            [matDatepicker]="pickerValidTo"
                            (focus)="pickerValidTo.open()"
                            [placeholder]="'GENERAL.PROPERTY.DUE_DATE' | translate"
                            (dateChange)="updateStartDate()"
                        />
                        <mat-datepicker-toggle matSuffix [for]="pickerValidTo"></mat-datepicker-toggle>
                        <mat-datepicker #pickerValidTo></mat-datepicker>
                    </mat-form-field>
                </div>
            </form>
        </mat-step>

        <mat-step [completed]="formGroup.valid">
            <ng-template matStepLabel>{{ 'PERFORMANCE_REVIEW.NAV.PERIODS' | translate }}</ng-template>

            <form [formGroup]="formGroup">
                <mat-form-field>
                    <mat-select formControlName="periodUnderReview" [placeholder]="'PERFORMANCE_REVIEW.PERIODS.PERIOD_UNDER_REVIEW' | translate">
                        <div *ngFor="let performancePeriod of filteredPerformancePeriods$ | async">
                            <mat-option [value]="performancePeriod.id" (click)="onPerformancePeriodSelected(performancePeriod)">
                                <span>{{ performancePeriod.startDate | date: 'shortDate' }} - {{ performancePeriod.endDate | date: 'shortDate' }}</span>
                            </mat-option>
                        </div>
                    </mat-select>
                </mat-form-field>
                <div class="mt-4 p-24 bg-gray-100">
                    <h2 class="text-base mt-0 font-medium">{{ 'PERFORMANCE_REVIEW.PERIODS.GOAL_SETTING_PERIOD' | translate }}</h2>
                    <mat-radio-group formControlName="goalSettingPeriod">
                        <mat-radio-button class="mr-48" *ngIf="closestPeriod" [value]="closestPeriod.id">
                            <span>{{ closestPeriod.startDate | date: 'shortDate' }} - {{ closestPeriod.endDate | date: 'shortDate' }} </span>
                        </mat-radio-button>

                        <mat-radio-button *ngIf="followUpPeriod" [value]="followUpPeriod.id">
                            <span>{{ followUpPeriod.startDate | date: 'shortDate' }} - {{ followUpPeriod.endDate | date: 'shortDate' }} </span>
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
            </form>
        </mat-step>

        <mat-step [completed]="formGroup.valid">
            <ng-template matStepLabel>{{ 'GENERAL.LABEL.PARTICIPANTS' | translate }}</ng-template>

            <div class="select-users-wrapper" fxLayout="column" fxLayoutAlign="start">
                <ng-container *ngIf="list.length">
                    <h3 class="mt-0 mb-8 text-base font-medium text-gray-600">{{ 'GENERAL.LABEL.SELECTED_USERS' | translate }}</h3>
                    <mat-chip-set class="chip-list wrap mb-12">
                        <mat-chip class="chip maxbrain-500" [removable]="removable" (removed)="removeFromList(item)" *ngFor="let item of list">
                            {{ item.fullName }}
                            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                        </mat-chip>
                    </mat-chip-set>
                </ng-container>

                <div *ngIf="dataSource">
                    <div fxLayout="row" fxLayoutAlign="flex-end">
                        <app-white-button class="mb-8" [label]="'GENERAL.BUTTON.SELECT_ALL'" (onClick)="addAllToList()"></app-white-button>
                    </div>

                    <div class="w-100-p table-wrapper border border-gray-300 rounded-sm">
                        <mat-table #table [dataSource]="dataSource">
                            <!-- Avatar Column -->
                            <ng-container matColumnDef="avatar">
                                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                                <mat-cell *matCellDef="let user">
                                    <div #avatarCell>
                                        <img class="avatar pointer" *ngIf="user.profilePicture?.url; else initials" [alt]="user.fullName" [src]="user.profilePicture?.url" />
                                        <ng-template #initials>
                                            <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ user.fullName | initials }}</div>
                                        </ng-template>
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <!-- First Name Column -->
                            <ng-container matColumnDef="firstName">
                                <mat-header-cell class="narrow" *matHeaderCellDef> {{ 'GENERAL.PROPERTY.FIRST_NAME' | translate }}</mat-header-cell>
                                <mat-cell *matCellDef="let user" class="narrow">
                                    <p #firstNameRow class="text-truncate font-semibold">
                                        {{ user.firstName }}
                                    </p>
                                </mat-cell>
                            </ng-container>

                            <!-- Last Name Column -->
                            <ng-container matColumnDef="lastName">
                                <mat-header-cell class="narrow" *matHeaderCellDef>
                                    {{ 'GENERAL.PROPERTY.LAST_NAME' | translate }}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let user" class="narrow">
                                    <p #lastNameRow class="text-truncate font-semibold">
                                        {{ user.lastName }}
                                    </p>
                                </mat-cell>
                            </ng-container>

                            <!-- Email Column -->
                            <ng-container matColumnDef="email">
                                <mat-header-cell class="wider pr-24" *matHeaderCellDef fxHide fxShow.gt-xs>
                                    {{ 'GENERAL.PROPERTY.EMAIL' | translate }}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let user" class="wider pr-24" fxHide fxShow.gt-xs>
                                    <p #emailRow class="text-truncate font-semibold">{{ user.email }}</p>
                                </mat-cell>
                            </ng-container>

                            <!-- Buttons Column -->
                            <ng-container matColumnDef="buttons">
                                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                                <mat-cell *matCellDef="let user">
                                    <div fxFlex="row" fxLayoutAlign="end center">
                                        <app-flat-button [label]="'GENERAL.BUTTON.ADD'" (onClick)="addToList(user)" *ngIf="!user.alreadyMember && !user.selected"></app-flat-button>
                                        <p *ngIf="user.alreadyMember">{{ 'GENERAL.LABEL.IN_GROUP' | translate }}</p>
                                        <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="removeFromList(user)" *ngIf="user.selected"></app-white-button>
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let user; columns: displayedColumns" matRipple> </mat-row>
                        </mat-table>
                    </div>
                </div>
            </div>
        </mat-step>
    </mat-horizontal-stepper>
</div>

<div class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="space-between center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>

    <div fxLayout="row">
        <ng-container *ngIf="!performanceTeamReview">
            <!-- Previous button: only show when not on the first step -->
            <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.PREVIOUS'" *ngIf="stepper.selectedIndex !== 0" (onClick)="goBack(stepper)"> </app-white-button>

            <!-- Next button: only show on the first step -->
            <app-flat-button
                class="mr-8"
                [label]="'GENERAL.BUTTON.NEXT'"
                (onClick)="goForward(stepper)"
                [disabled]="!formGroup.valid"
                *ngIf="stepper.selectedIndex === 0 || stepper.selectedIndex === 1"
            >
            </app-flat-button>
        </ng-container>

        <!-- Next button:  show on the first step if it's edit mode or on second step when creating performance review -->
        <app-flat-button
            [label]="'GENERAL.BUTTON.SAVE'"
            [disabled]="!formGroup.valid || (!list.length && !performanceTeamReview)"
            (onClick)="save()"
            *ngIf="stepper.selectedIndex === 2 || performanceTeamReview"
        ></app-flat-button>
    </div>
</div>
